import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AssetGroup } from 'src/app/assets/components/asset-filters/asset-filters.component';
import { AssetCategory } from 'src/app/models/asset-category';

@Component({
  selector: 'app-homesick-category-form',
  templateUrl: './homesick-category-form.component.html',
  styleUrls: ['./homesick-category-form.component.scss'],
})
export class HomesickCategoryFormComponent implements OnInit {
  selectedCategory: AssetCategory;
  categoriesSortedByGroup: AssetGroup[];
  defaultDays: number;

  constructor(
    private dialogRef: MatDialogRef<HomesickCategoryFormComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      defaultHomesickDays: number;
      categories$: Observable<AssetCategory[]>;
    }
  ) {
    this.defaultDays = data.defaultHomesickDays;
  }

  ngOnInit(): void {
    this.data.categories$?.subscribe((categories) => {
      // Group asset categories by the asset_group then convert it to an array
      const groupObject: Record<string, AssetCategory[]> = categories.reduce(
        (prev, currentCategory: AssetCategory) => ({
          ...prev,
          [currentCategory.asset_group]: [
            ...(prev[currentCategory.asset_group] || []),
            currentCategory,
          ],
        }),
        {}
      );
      this.categoriesSortedByGroup = Object.entries(groupObject).map(
        ([key, groupCategories]) => ({
          group: key,
          allSelected: false,
          categories: groupCategories,
        })
      );
    });
  }

  addCategory() {
    // Close the dialog returning the new category
    if (this.selectedCategory && this.defaultDays) {
      this.dialogRef.close({
        id: this.selectedCategory.id,
        name: this.selectedCategory.name,
        length: this.defaultDays,
      });
    } else {
      this.dialogRef.close();
    }
  }

  getAssetGroups(): Observable<Record<string, AssetCategory[]>> {
    return this.data.categories$.pipe(
      map((categories) =>
        categories.reduce((prev, category) => {
          const group = category.asset_group;
          return {
            ...prev,
            [group]: [...(prev[group] || []), category],
          };
        }, {})
      )
    );
  }
}
